/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const AmbassadorInvFragment = {
  AmInv: gql`
    fragment AmInvQuery on ambassadorInvite_Entry {
      ambassadorInviteTitle
      ambassadorInviteContent
      ambassadorInviteRightContent
      styles
      ctaLabel
      ctaStyle
      typeHandle
    }
  `,
};
